import React from 'react';
import { SubmitButton } from '@app/components/SubmitButton';
import {
  useAddress,
  useChainId,
  useSigner,
  useSwitchChain
} from '@thirdweb-dev/react';
import { Mode } from '@thirdweb-dev/chains';
import { CustomConnectWalletButton } from '@app/components/CustomConnectWalletButton';
import { useAllowance } from '@app/hooks/token/useAllowance';
import { useFormContext } from 'react-hook-form';
import { useConfig } from '@app/config';
import { useApproval } from '@app/hooks/token/useApproval';

export const SubmitSection = () => {
  const address = useAddress();
  const chainId = useChainId();
  const switchChain = useSwitchChain();
  const config = useConfig();
  const {
    watch,
    formState: { isSubmitting }
  } = useFormContext();
  const signer = useSigner();

  const token = watch('token');
  const amount = watch('amount');

  const { mutate: approve, isLoading: isApproving } = useApproval();
  const { data: allowance, isLoading: isLoadingAllowance } = useAllowance({
    token,
    spenderAddress: config?.CONTRACTS.NFT_MARKETPLACE
  });

  if (!address) {
    return <CustomConnectWalletButton />;
  }

  if (chainId !== Mode.chainId) {
    return (
      <SubmitButton
        label="Switch chain"
        isLoading={false}
        sx={{ marginTop: 0 }}
        onClick={() => switchChain(Mode.chainId)}
      />
    );
  }

  if (!allowance || isLoadingAllowance) {
    return (
      <SubmitButton
        label="Loading..."
        isLoading
        onClick={() => switchChain(Mode.chainId)}
        sx={{ marginTop: 0 }}
      />
    );
  }

  if (+allowance.formattedValue < +amount) {
    return (
      <SubmitButton
        label="Approve token spend"
        isLoading={isApproving}
        sx={{ marginTop: 0 }}
        onClick={() => {
          approve({
            amount,
            signer,
            token,
            network: Mode,
            spenderAddress: config?.CONTRACTS.NFT_MARKETPLACE
          });
        }}
      />
    );
  }

  return (
    <SubmitButton isLoading={isSubmitting} label="Make offer" type="submit" />
  );
};
